<template lang="pug">
  v-select(
    v-model="p_code"
    :items="masterList"
    item-text="label"
    :item-value="itemValue"
    :clearable="clearable"
    :label="label"
    :multiple="multiple"
    :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")
</template>

<script>
import * as Enum from "@/assets/js/enum";

export default {
  props: {
    // TODO:type:String 必須でありながらNullがはいる可能性があるため回避。（※clearable, 初期値）
    // eslint-disable-next-line vue/require-prop-types
    code: {
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    errorHandlerMethod: {
      type: Function,
      default() {
        return null;
      }
    },
    errorHandlerMethodArg: {
      type: String,
      default() {
        return null;
      }
    },
    useFilter: {
      type: Boolean,
      default() {
        return false;
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    label: {
      type: String,
      default: "失注理由"
    }
  },
  data() {
    return {
      defaultErrorHandlerMethodArg: "lostOrderReason"
    };
  },
  computed: {
    p_code: {
      get() {
        return this.code;
      },
      set(newVal) {
        if (this.code !== newVal) this.$emit("update:code", newVal);
      },
      required: true
    },
    masterList: {
      get() {
        return Enum.Utils.enumToList(Enum.LostOrderReasonType);
      }
    },
    errorHandlerMethodArgComputed: {
      get() {
        if (this.errorHandlerMethodArg == null) {
          return this.defaultErrorHandlerMethodArg;
        }
        return this.errorHandlerMethodArg;
      }
    },
    itemValue: {
      get() {
        if (this.useFilter) {
          return "label";
        } else {
          return "code";
        }
      }
    }
  },
  methods: {}
};
</script>

<style scoped></style>
